import React, { useContext, useMemo } from 'react';

import { FrequentlyBoughtTogetherContext } from '../context';

import FrequentlyBoughtTogetherAddItemsToCart from './FrequentlyBoughtTogetherAddItemsToCart';
import FrequentlyBoughtTogetherTotalPrice from './FrequentlyBoughtTogetherTotalPrice';

import './FrequentlyBoughtTogetherTotalPriceAddToCart.scss';

const FrequentlyBoughtTogetherTotalPriceAddToCart = () => {

	const { selectedProductsCount, products } = useContext(FrequentlyBoughtTogetherContext);
	const addToCartText = useMemo(() => {

		if (selectedProductsCount === 2 && products.length === 2) {

			return 'Add Both To Cart';

		}

		if (selectedProductsCount === products.length) {

			return `Add All ${selectedProductsCount} To Cart`;

		}

		return `Add ${selectedProductsCount} To Cart`;

	}, [ selectedProductsCount ]);
	const noItemsSelectedMessage = 'Select items to buy together.';

	return (
		<div className="FrequentlyBoughtTogetherTotalPriceAddToCart">
			{selectedProductsCount > 0 ? (
				<>
					<FrequentlyBoughtTogetherTotalPrice />
					<FrequentlyBoughtTogetherAddItemsToCart
						dataCaptureMainElement="frequentlyBoughtTogetherPDP"
						skipMainProductSkuView
					>
						{addToCartText}
					</FrequentlyBoughtTogetherAddItemsToCart>
				</>
			) : (
				<div
					className="FrequentlyBoughtTogetherTotalPriceAddToCart__message"
				>
					<span className="lpIcon-alert" />
					{' '}
					{noItemsSelectedMessage}
				</div>
			)}
		</div>
	);

};

export default FrequentlyBoughtTogetherTotalPriceAddToCart;
